<template>
  <v-app>
    <YieldLayout/>
  </v-app>
</template>

<script>
import YieldLayout from './components/YieldLayout.vue';

export default {
  name: 'app',
  components: {
    YieldLayout,
  },
};
</script>

<style lang="scss">

  $font-size-base: 0.875rem;

  @import "../node_modules/bootstrap/scss/bootstrap";


  @include media-breakpoint-up(xs) {
    .panel-heading {
      font-size: 14px;
    }
    .the-number {
      font-size: 70px;
      font-weight: 100;
    }
    .callout {
      padding-top: 40px;
      margin-left: 0;
      font-size: .7rem;
    }
  }

  @include media-breakpoint-up(md) {
    .panel-heading {
      font-size: 15px;
    }
    .the-number {
      font-size: 70px;
      font-weight: 100;
    }
    .callout {
      padding-top: 40px;
      margin-left: 0;
      font-size: .7rem;
    }
  }

  @include media-breakpoint-up(lg) {
    .panel-heading {
      font-size: 23px;
    }
    .the-number {
      font-size: 80px;
      font-weight: 100;
    }
    .callout {
      padding-top: 40px;
      margin-left: 0;
      font-size: .875rem;
    }
  }

  body {
    font-weight: 300;
    color: #7D797B;
    padding-bottom: 10px;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  h3 {
    font-weight: 300;
  }

  .heading {
    margin-bottom: -10px;
  }

  .heading a {
    color: #686868;
  }

  .about {
    float: right;
    margin-top: 18px;
  }



  .brand {
    font-family: sans-serif;
    font-size: 32px;
    font-weight: 100;
    color: #686868;
  }

  .panel {
    padding: 10px;
    background: #ebeaea;
    margin: 5px;
    border-radius: 10px;
  }

  .panel-body {
    padding: 0;
    white-space: nowrap;
    overflow: hidden;
    position: relative;
  }

  .panel-heading {
    padding: 0;
    color: #7D797B;
    margin-top: 0;
    font-weight: 300;
    white-space: nowrap;
    overflow: hidden;
  }

  p.inflation-rate {
    margin-bottom: 15px;
    color: #D51010;
    font-weight: 500;
    font-size: 13px;
  }

  .negative {
    color: #d51010
  }

  .positive {
    color: #10d522
  }

  .neutral {
    color: #848484
  }

  p.scale-trigger {
    margin-bottom: 0;
    margin-top: 10px;
  }
</style>
